import { HOW_STEPS } from "@/lib/assets";
import { SectionHeading, Reveal } from "@/components/Section";
import ZoomImage from "@/components/ZoomImage";

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32" data-testid="how-it-works">
      <SectionHeading
        overline="Fill · Wear · Dispense"
        title="How the delivery system works."
        subtitle="Four simple steps from filling the band to delivering care into your palm. Precise, on-demand dispensing powered by the patented breathing valve and reservoir."
        testId="how-it-works-heading"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mt-16">
        {HOW_STEPS.map((step, i) => (
          <Reveal key={step.title} delay={(i % 4) * 0.08}>
            <div data-testid={`how-step-${i}`} className="group h-full">
              <div className="relative overflow-hidden border border-zinc-800 bg-[#0a0a0a] group-hover:border-[#00e5ff]/40 transition-colors duration-500">
                <span className="absolute top-4 left-4 z-10 font-mono text-sm tracking-[0.3em] text-[#00e5ff] bg-black/50 backdrop-blur-sm px-3 py-1 border border-zinc-700">
                  0{i + 1}
                </span>
                <ZoomImage
                  src={step.img}
                  alt={step.title}
                  caption={`Step 0${i + 1} · ${step.title}`}
                  testId={`how-step-image-${i}`}
                  className="w-full aspect-square object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <h3 className="font-heading text-xl font-medium mt-6">{step.title}</h3>
              <p className="font-body text-zinc-400 leading-relaxed mt-2">{step.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
